<div class="formulario">
  <div class="container">
    <form class="myForm" [formGroup]="packForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
      <div class="container">


        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Nombre</label>
              <input class="form-control" type="text" formControlName="nombre">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Foto</label>
              <div class="row">
                <div class="col-8">

                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,1)">
                </div>
                <div class="col-4" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(1)" type="button">
                    <i class="fa fa-camera"></i>
                  </button>
                  <button class="btn btn-danger"  (click)="deleteImagen(1)" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
            <div class="form-group text-center" *ngIf="imgURL">


              <img [src]="imgURL" *ngIf="imgURL" class="image_articulo">

            </div>
          </div>

        </div>


        <div class="row">
<!--           <div class="col-lg-5">
            <div class="form-group">
              <label>Proveedor</label>
              <app-generic-dropdown [database]="'proveedores'" [item]="this.packForm.get('idProveedor1').value"
                (selectItem)="setProveedor($event,1)">
              </app-generic-dropdown>
            </div>
          </div> -->
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown #articulos1 [database]="'warticulos_lista'" [item]="this.packForm.get('idArticulo1').value"
                (selectItem)="setArticulo($event,1)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad1">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.packForm.get('idArticulo1').value > 0">
         
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown  [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo2').value"
                (selectItem)="setArticulo($event,2)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad2">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.packForm.get('idArticulo2').value > 0">
      
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo3').value"
                (selectItem)="setArticulo($event,3)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad3">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.packForm.get('idArticulo3').value > 0">
      
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown #articulos4 [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo4').value"
                (selectItem)="setArticulo($event,4)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad4">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.packForm.get('idArticulo4').value > 0">
      
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo5').value"
                (selectItem)="setArticulo($event,5)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad5">
            </div>
          </div>
        </div>

        <div class="row" *ngIf="this.packForm.get('idArticulo5').value > 0">

          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown [database]="'warticulos_lista'" [item]="this.packForm.get('idArticulo6').value"
                (selectItem)="setArticulo($event,6)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad6">
            </div>
          </div>
        </div>

        <div class="row" *ngIf="this.packForm.get('idArticulo6').value > 0">
     
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo7').value"
                (selectItem)="setArticulo($event,7)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad7">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.packForm.get('idArticulo7').value > 0">
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo8').value"
                (selectItem)="setArticulo($event,8)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad8">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.packForm.get('idArticulo8').value > 0">

          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo9').value"
                (selectItem)="setArticulo($event,9)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad9">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.packForm.get('idArticulo9').value > 0">
          <div class="col-lg-10">
            <div class="form-group">
              <label>Artículo</label>
              <app-generic-dropdown [database]="'warticulos_lista'"  [item]="this.packForm.get('idArticulo10').value"
                (selectItem)="setArticulo($event,10)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="">Cantidad</label>
              <input class="form-control alider" type="number" formControlName="cantidad10">
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="">Observaciones</label>
              <textarea class="form-control" formControlName="observaciones" rows="2"></textarea>
            </div>
          </div>
        </div>


      </div>


      <br>

      <div class="botones">
        <button type="button" class="btn btn-warning" (click)="regresar()"><i class="fa fa-chevron-left"
            aria-hidden="true"></i> Volver</button>
        <button type="submit" class="btn btn-success" [disabled]="packForm.invalid || noGrabar"><i class="fa fa-save"
            aria-hidden="true"></i> Enviar</button>
      </div>

    </form>
  </div>
</div>
<p-toast [style]="{marginTop: '80px'}"></p-toast>

<p-dialog [visible]="showCamera">
  <div *ngIf="showCamera">
    <app-camera (sendImage)="getImage($event)" (closeCamera)="closeDialog($event)"
    [fileName]='fileName'
    [numberPhoto]='numberPhoto'
    ></app-camera>
  </div>

</p-dialog>
